// extracted by css-extract-rspack-plugin
export default {"noResults":"JbaBCK0QGUmqXK5c","loadingResults":"NdfUFVzN_4ICMh9Y"};